import { AxiosStatic } from "axios";

export class AllowedCovid19FeaturesApi {
    private apiUrl = "/api/allowedCovid19Features";
    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async load(): Promise<string[]> {
        const response = await this.axios.get<string[]>(this.apiUrl);
        return response.data;
    }
}
